<template>
  <section class="mt-5">
    <!-- Block Button: "มีเมนู" -->
    <Button
      type="button"
      intent="secondary"
      @click="isOpen = true"
      aria-label="เปิดเมนู"
      full
      class="rounded-md"
    >
      <div class="flex items-center justify-between w-full">
        <!-- left side -->
        <div v-if="title">
          <span class="mr-2">{{ title }}</span>
        </div>

        <!-- right side -->
        <div>
          <span>{{ $t('myAccount.menu') }}</span>
          <Icon name="chevron-right" class="w-6 h-6" style="display: inline" />
        </div>
      </div>
    </Button>

    <!-- Slide-in Fullscreen Menu (from left) -->
    <transition name="slide-left">
      <div
        v-if="isOpen"
        class="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center space-y-8 text-xl"
      >
        <!-- Close Button -->
        <button
          @click="isOpen = false"
          class="absolute top-6 right-6 text-gray-600 hover:text-red-500 text-3xl"
          type="button"
          aria-label="ปิดเมนู"
        >
          &times;
        </button>

        <!-- Navigation Items -->
        <!-- Menu List -->
        <nav class="flex flex-col gap-4 mt-12">
          <NuxtLinkLocale
            v-for="(item, index) in menuList"
            :key="index"
            :to="item.url"
            class="flex items-center gap-3 text-gray-800 text-lg hover:text-blue-600"
            @click="isOpen = false"
          >
            <span
              :class="{
                'text-primary-tangerine': includes(currentPath, item.url)
              }"
              >{{ item.name }}
            </span>
          </NuxtLinkLocale>
        </nav>
      </div>
    </transition>
  </section>
</template>

<script setup lang="ts">
import { includes } from 'lodash-es'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps({
  title: {
    type: String,
    default: ''
  }
})

const route = useRoute()
const { t } = useI18n()

const isOpen = ref(false)
const currentPath = computed(() => route.path)

const menuList = [
  {
    name: t('terms.termsAndConditions'),
    url: '/terms-and-conditions'
  },
  {
    name: t('terms.personalDataConsent'),
    url: '/personal-data-consent'
  },
  {
    name: t('terms.privacyPolicy'),
    url: '/privacy-policy'
  }
]
</script>

<style scoped>
.slide-left-enter-active,
.slide-left-leave-active {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}
.slide-left-enter-from {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-left-enter-to {
  transform: translateX(0);
  opacity: 1;
}
.slide-left-leave-from {
  transform: translateX(0);
  opacity: 1;
}
.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
